import styled, { keyframes } from 'styled-components';

const wobble = keyframes`
    0% {
        transform: translateY(0px);
    }
    5% {
        transform: translateY(-8px);
    }
    10% {
        transform: translateY(0px);
    }
    15% {
        transform: translateY(-4px);
    }
    20% {
        transform: translateY(0px);
    }
    25% {
        transform: translateY(-6px);
    }
    30% {
        transform: translateY(0px);
    }
    35% {
        transform: translateY(-3px);
    }
    40% {
        transform: translateY(0px);
    }
    40%, 60% {
        transform: translateY(0px);
    }
    65% {
        transform: translateY(-8px);
    }
    70% {
        transform: translateY(0px);
    }
    75% {
        transform: translateY(-4px);
    }
    80% {
        transform: translateY(0px);
    }
    85% {
        transform: translateY(-6px);
    }
    90% {
        transform: translateY(0px);
    }
    95% {
        transform: translateY(-3px);
    }
    100% {
        transform: translateY(0px);
    }
`;

export const TooltipContainer = styled.div`
  font-family: Montserrat;
  position: fixed;
  top: ${(props) => (props.fromCategory ? '80px' : '100px')};
  right: 11%;
  z-index: 999;
  color: #2d2c2c;
  display: ${(props) => (props.showSsoTooltip ? 'block' : 'none')};

  &.wobble-animation {
    animation: ${wobble} 5s ease-in-out infinite;
  }

  @media (max-width: 720px) {
    top: ${(props) => (props.fromCategory || props.fromPdp ? '55px' : '85px')};
    right: 3%;
  }

  .tooltip {
    display: flex;
    gap: 10px;
    background-color: #ffbcc3;
    padding: 15px 18px;
    border-radius: 8px;

    @media (max-width: 720px) {
      gap: 10px;
      padding: 15px 12px;
    }

    .tooltip-content {
      display: flex;
      justify-content: space-between;
    }
    .title {
      font-size: 16px;
      font-weight: 600;

      @media (max-width: 720px) {
        font-size: 14px;
      }
    }

    .description {
      font-size: 13px;
      font-weight: 500;
      color: #2d2c2c;
      margin-top: 5px;
      @media (max-width: 720px) {
        font-size: 10px;
      }
    }

    #kwikpass-sso-container button {
      width: 100%;
      min-width: 300px;
      border-radius: 5px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      background-color: #ef4e5e;
      color: #fff;
      font-family: Montserrat;
      font-weight: 600;
      font-size: 15px;
      margin-top: 10px;
      gap: 0px;
      padding-top: 7px;
      padding-bottom: 3px;

      @media (max-width: 720px) {
        padding-top: 7px;
        padding-bottom: 3px;
        font-size: 12px;
        min-width: 270px;
      }

      .title {
        font-size: 14px;
        @media (max-width: 720px) {
          font-size: 12px;
        }
      }

      .branding span {
        font-size: 8px;
      }

      .branding img {
        width: 60px;
        height: 60px;
      }
    }
  }

  .sso-button {
    width: 100%;
    min-width: 300px;
    border-radius: 5px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    background-color: #ef4e5e;
    color: #fff;
    font-family: Montserrat;
    font-weight: 600;
    font-size: 15px;
    margin-top: 15px;
    padding-top: 10px;
    padding-bottom: 10px;
    outline: none;
    border: none;
    cursor: pointer;

    @media (max-width: 720px) {
      padding-top: 7px;
      padding-bottom: 7px;
      font-size: 12px;
      min-width: 270px;
    }
  }
  .upward-arrow {
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 13px solid #ffbcc3;
    margin-left: auto;
    margin-right: 20px;
  }

  .CrossIcon {
    cursor: pointer;
  }
`;
